import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AboutPillarItem } from '../../about.models';

@Component({
  selector: 'app-about-pillars-section',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './about-pillars-section.component.html',
  styleUrl: './about-pillars-section.component.scss'
})
export class AboutPillarsSectionComponent {
  @Input({ required: true }) pillars: AboutPillarItem[] = [];
}
